import { Component, Input } from '@angular/core';
import { IBrandResources } from 'src/app/domain/interfaces/brand/interface-brand-resources';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-finsights',
  templateUrl: './footer-finsights.component.html',
  styleUrl: './footer-finsights.component.scss'
})
export class FooterFinsightsComponent {
  @Input() currentYear!: number;
  @Input() brandResources!: IBrandResources;
  public environment = environment;
}
